/**
 * Product Search Field - text input matching `ls_products.name` OR `sku` (ILIKE).
 */
import React from 'react'
import { TextField, Typography, Box } from '@mui/material'
import { Search as SearchIcon } from '@mui/icons-material'

interface ProductSearchFieldProps {
  value: string
  onChange: (value: string) => void
}

const labelStyle = {
  fontWeight: 600,
  color: 'text.secondary',
  fontSize: '0.75rem',
  mb: 0.5,
  display: 'block',
}

const ProductSearchField: React.FC<ProductSearchFieldProps> = ({ value, onChange }) => (
  <Box>
    <Typography component="label" sx={labelStyle}>Name or SKU</Typography>
    <TextField
      fullWidth
      size="small"
      placeholder="Search product name or SKU"
      variant="outlined"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      InputProps={{ startAdornment: <SearchIcon sx={{ mr: 1, color: 'action.active' }} /> }}
    />
  </Box>
)

export default ProductSearchField
